import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Shuffle = createReactComponent("Shuffle", ["svg", defaultAttributes, [["polyline", {
  points: "16 3 21 3 21 8",
  key: "1pw6d7"
}], ["line", {
  x1: "4",
  y1: "20",
  x2: "21",
  y2: "3",
  key: "8zqxau"
}], ["polyline", {
  points: "21 16 21 21 16 21",
  key: "b8qqkz"
}], ["line", {
  x1: "15",
  y1: "15",
  x2: "21",
  y2: "21",
  key: "lgqqxc"
}], ["line", {
  x1: "4",
  y1: "4",
  x2: "9",
  y2: "9",
  key: "1tsi8"
}]]]);
export default Shuffle;